module.exports = __webpack_public_path__ + "b4e07b40e49c19b2157456cbf82c81af.svg";